import { colors } from './styles';

/**
 * Resolves a color token to its actual color value
 * Supports both dot notation (gray.100) and direct color values (#fff, red, etc.)
 */
export const resolveColor = (colorToken: string): string => {
  if (!colorToken) return '';

  // If it's already a valid CSS color (starts with #, rgb, hsl, or is a named color)
  if (
    colorToken.startsWith('#') ||
    colorToken.startsWith('rgb') ||
    colorToken.startsWith('hsl') ||
    colorToken.match(/^[a-z]+$/i)
  ) {
    return colorToken;
  }

  // Handle dot notation (e.g., "gray.100")
  const [colorName, shade] = colorToken.split('.');

  if (colorName && shade) {
    // Use bracket notation to safely access colors
    const colorSet = colors[colorName as keyof typeof colors];
    if (colorSet && typeof colorSet === 'object') {
      const colorValue = (colorSet as Record<string, string>)[shade];
      if (colorValue) {
        return colorValue;
      }
    }
  }

  // If we can't resolve it, return the original token
  return colorToken;
};
